import React, { useState } from 'react';
import ToggleHoverCard from '../../../../@jumbo/components/Common/ToggleHoverCard';
import Box from '@material-ui/core/Box';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import DataChart from './DataChart';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import useStyles from './index.style';
import { CircularProgress } from '@material-ui/core';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';

const AnalyticContent = ({ rise, hovered, analyticData, primaryColor, secondaryColor }) => {
  const classes = useStyles();

  return hovered ? (
    <div className={classes.toggleAnalyticsContent}>
      <div className={classes.toggleAnalyticsContentInner}>
        <Typography className={classes.titleRoot} component="div" variant="h1">
          {analyticData.onHover.amount}
        </Typography>
        <Box display="flex" alignItems="center" component="p" color="text.secondary" whiteSpace="nowrap" fontSize={16}>
          <span>{analyticData.label}</span>
          <span
            className="ml-2"
            style={{
              display: 'flex',
              alignItems: 'center',
              color: primaryColor.solid,
            }}>
            {analyticData.onHover.percentage}
            <span className="ml-2"></span>
          </span>
        </Box>
      </div>
    </div>
  ) : (
    <div className={classes.toggleAnalyticsContent}>
      <div className={classes.toggleAnalyticsContentInner}>
        <Typography className={classes.titleRoot} component="div" variant="h1">
          {analyticData.amount == '' && (
            <React.Fragment>
              <CircularProgress size={32} />
            </React.Fragment>
          )}
          {analyticData.amount}
        </Typography>
        <Box display="flex" alignItems="center" component="p" color="text.secondary" whiteSpace="nowrap" fontSize={16}>
          <span>{analyticData.label}</span>
          <span
            className="ml-2"
            style={{
              display: 'flex',
              alignItems: 'center',
              color: secondaryColor.solid,
            }}>
            {analyticData.percentage}
            <span className="ml-2">
              {rise == '1' && analyticData.amount != '' && <TrendingUpIcon />}
              {rise == '0' && analyticData.amount != '' && <TrendingDownIcon />}
            </span>
          </span>
        </Box>
      </div>
    </div>
  );
};

const ToggleAnalyticsCard = ({ data }) => {
  var { title, hoverButton, primaryColor, secondaryColor, analyticData, chartData } = data;
  if (primaryColor == null) primaryColor = { solid: '#ADDC4C', light: '#D7F5B1' };
  if (secondaryColor == null) secondaryColor = { solid: '#ADDC4C', light: '#D7F5B1' };
  if (hoverButton == null) hoverButton = { text: '', color: '#5D9405', hoverText: '', hoverColor: '#fff' };
  if (title == null) title = '';
  if (chartData == null) chartData = { past: [], current: [] };
  if (analyticData == null)
    analyticData = {
      amount: '',
      label: '',
      percentage: '',
      onHover: {
        amount: '',
        percentage: '',
      },
    };

  const [hovered, setHovered] = useState(false);
  const [toggled, setToggled] = useState(false);
  const classes = useStyles();

  return (
    <ToggleHoverCard
      className={clsx(classes.toggleCardRoot, toggled ? 'chart-active' : '')}
      title={title}
      isHovered={setHovered}
      isToggled={setToggled}
      hoverAction={
        <span
          className={classes.toggleHoverBtn}
          style={{
            backgroundColor: hovered ? primaryColor.solid : primaryColor.light,
            color: hovered ? hoverButton.hoverColor : hoverButton.color,
            fontSize: 'x-small',
          }}>
          {hovered ? hoverButton.hoverText : hoverButton.text}
        </span>
      }
      toggleAction={<ShowChartIcon color={toggled ? 'primary' : 'action'} />}>
      {chartData.past == null && (
        <React.Fragment>
          <div className={clsx(classes.emptyListContainer, classes.flexRow, 'CmtList-EmptyResult')}>
            <CircularProgress size={16} />
          </div>
        </React.Fragment>
      )}
      {chartData.past != null && (
        <React.Fragment>
          <AnalyticContent
            hovered={hovered}
            analyticData={analyticData}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          />

          {toggled && (
            <div className={classes.dataChartRoot}>
              <DataChart
                data={hovered ? chartData.past : chartData.current}
                color={hovered ? primaryColor.solid : secondaryColor.solid}
                bgColor={hovered ? primaryColor.light : secondaryColor.light}
              />
            </div>
          )}
        </React.Fragment>
      )}
    </ToggleHoverCard>
  );
};

export default ToggleAnalyticsCard;
